import React, {useState} from "react";
import {useSelector} from "react-redux";
import {
    HikerMarker
} from "./Marker";
import {getStops, getSteps, getStepGeojson, getCurrentDirectionFromState} from '../../../../../data/booking/selectors/hike'
import {
    BAG_TRANSPORT,
    REGULAR_SHUTTLE,
    CAR_PARKING,
    CAR_TRANSPORT,
    BIKE_TRANSPORT,
    PEOPLE_TRANSPORT
} from "../../../../../data/booking/constants/service_types";
import {
    BagTransport,
    BikeTransport,
    CarParking,
    CarTransport,
    RegularShuttle,
    PeopleTransport
} from "../../../../booking/components/map/leaflet/Services";

function HikeLayer(){

    const {hikerMarkerCoordinates, direction, trip, hike, kmlData, entities} = useSelector(state => state.booking.map)
    const departure = trip.startStep
    const arrival = trip.endStep
    const services = entities.services
    const isLoop = hike?.pathDetails?.loop
    const serviceType = trip.serviceType ? trip.serviceType : (trip.serviceId ? services[trip.serviceId].type : null)
    let stops = getStops(trip)
    let steps = getSteps(trip)
    const currentDirection = useSelector(state => getCurrentDirectionFromState(state))

    if(departure) {
        switch (serviceType) {
            case PEOPLE_TRANSPORT:
                return <PeopleTransport departure={departure} arrival={arrival}/>
            case BIKE_TRANSPORT:
                return <BikeTransport departure={departure} arrival={arrival}/>
            case REGULAR_SHUTTLE:
                return <RegularShuttle departure={departure} arrival={arrival}/>
            case CAR_TRANSPORT:
                return <CarTransport departure={departure} arrival={arrival}/>
            case BAG_TRANSPORT:
                let geoJson = null;
                if (kmlData && trip.hike && kmlData[trip.hike.id]) {
                    const {LineString} = kmlData[trip.hike.id];
                    geoJson = getStepGeojson(departure, arrival, LineString, direction, isLoop && currentDirection == -1)
                }
                return <BagTransport departure={departure} arrival={arrival} geoJson={geoJson} stops={stops}
                                     steps={steps}/>
            case CAR_PARKING:
                return <CarParking departure={departure}/>
            default:
                return <>
                    {hikerMarkerCoordinates &&
                        <HikerMarker position={[hikerMarkerCoordinates[1], hikerMarkerCoordinates[0]]}/>}
                </>
        }
    }
}

export default HikeLayer